<template>
  <header class="header flex column">
    <div class="navigationBar flex ai jcs">
      <div class="flex ai jcs" style="width: 3.48rem">
        <img @click="showPopUp = !showPopUp" class="iconMenu" :style="showPopUp ? 'width: 0.33rem;height: 0.34rem;' : ''" :src="require(`@/assets/mobile/${showPopUp ? 'iconClose' : 'iconMenu'}.png`)" alt="" />
        <img @click="router.push('/mobileHome')" class="logo" src="@/assets/header/logo.png" alt="" />
      </div>
      <div class="flex ai">
        <div class="flex column">
          <img @click="jumpToExternal('天猫')" class="tianmao" src="@/assets/header/smallTianMao.svg" alt="" />
          <div class="dividingLine"></div>
          <img @click="jumpToExternal('京东')" class="jingdong" src="@/assets/header/smallJingDong.svg" alt="" />
        </div>
        <img class="logoBayer" src="@/assets/header/logoBayer.png" alt="" />
      </div>
    </div>
    <transition name="fade">
      <div v-if="showPopUp" class="popUp-productFamily flex column">
        <div class="popup-listItem flex column">
          <div @click="productFamily" class="flex ai jcs">
            <div class="flex ai">
              <div class="popup-listItem-name">产品家族</div>
              <div class="popup-listItem-link">/Products</div>
            </div>
            <img :style="showExpansionItem ? 'transform: rotate(180deg);' : ''" class="iconExpand" src="@/assets/mobile/iconExpand.png" alt="" />
          </div>
          <transition name="fade">
            <div v-if="showExpansionItem">
              <div @click="enterProduct('专业营养')" class="popup-expansionItem flex ai">
                <div class="popup-expansionItem-name">专业营养</div>
                <div class="popup-expansionItem-link">/Professional nutrition</div>
              </div>
              <div @click="enterProduct('基础营养')" class="popup-expansionItem flex ai">
                <div class="popup-expansionItem-name">基础营养</div>
                <div class="popup-expansionItem-link">/Basic nutrition</div>
              </div>
              <div @click="enterProduct('果味营养')" class="popup-expansionItem flex ai">
                <div class="popup-expansionItem-name">果味营养</div>
                <div class="popup-expansionItem-link">/Fruity nutrition</div>
              </div>
            </div>
          </transition>
        </div>
        <div @click="jumpToThePage('畅销明星')" class="popup-listItem flex ai">
          <div class="popup-listItem-name">畅销明星</div>
          <div class="popup-listItem-link">/Best-selling star</div>
        </div>
        <div @click="jumpToThePage('关于')" class="popup-listItem flex ai">
          <div class="popup-listItem-name">关于One A Day®</div>
          <div class="popup-listItem-link">/About One A Day®</div>
        </div>
      </div>
    </transition>
  </header>
  <!-- 跳转弹窗 -->
  <div v-if="showPopUpJump" class="popup-jump flex ai jcc">
    <div class="jumpBox flex column ai">
      <div class="jumpTxt1">您正在离开One A Day官网页面</div>
      <div class="jumpTxt2">你已选择进入第三方网站，你将离开拜耳所属的网站并去往第三方独立运营并不被拜耳管理的网络平台。拜耳将不对上述网站的内容及运营承担任何责任。</div>
      <div class="jumpTxt3">点击“取消”返回当前One A Day网页，点击“继续”访问第三方网站。</div>
      <div class="flex jcs" style="width: 100%; margin-top: 0.32rem; padding: 0 1.2rem; box-sizing: border-box">
        <div @click="jumpExternal" class="btnContinue flex ai jcc">继续</div>
        <div @click="showPopUpJump = false" class="btnCancel flex ai jcc">取消</div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { useRouter, useRoute } from "vue-router";
const router = useRouter();
// 是否展示弹窗
const showPopUp = ref(false);
// 跳转页面名称
const pageName = ref("");
const jumpToThePage = (name) => {
  pageName.value = name;
  showPopUp.value = false;
  if (name == "首页") {
    router.push("/");
  } else if (name == "畅销明星") {
    router.push("/MobileBestSellingStar");
  } else if (name == "关于") {
    router.push("/mobileAbout");
  }
};
// 是否展示产品家族展开项
const showExpansionItem = ref(false);
// 产品家族点击事件
const productFamily = () => {
  showExpansionItem.value = !showExpansionItem.value;
};
// 进入产品页面
const enterProduct = (type) => {
  showPopUp.value = false;
  router.replace({ name: "MobileProduct", query: { type: type } });
};
// 是否展示跳转弹窗
const showPopUpJump = ref(false);
// 跳转名称
const jumpName = ref("");
// 跳转外部网站
const jumpToExternal = (name) => {
  showPopUpJump.value = true;
  jumpName.value = name;
};
const jumpExternal = () => {
  if (jumpName.value == "天猫") {
    window.location.href = "https://oneaday.tmall.hk/shop/view_shop.htm?spm=pc_detail.29232929.shop_block.dshopinfo.48c67dd6wiDCEV";
  } else if (jumpName.value == "京东") {
    window.location.href = "https://mall.jd.hk/index-1000107607.html";
  }
};
</script>

<style lang="scss" scoped>
.header {
  width: 100%;
  height: 1.51rem;
  background: #13104c;
  position: relative;
}
.iconMenu {
  width: 0.43rem;
  height: 0.35rem;
}
.navigationBar {
  height: 100%;
  padding: 0 0.32rem;
}
.logo {
  width: 2.02rem;
  height: 0.82rem;
}
.tianmao {
  width: 1.25rem;
  height: 0.21rem;
}
.jingdong {
  margin-top: 0.2rem;
  width: 1.31rem;
  height: 0.18rem;
}
.dividingLine {
  margin-top: 0.2rem;
  width: 1.29rem;
  height: 0.01rem;
  background: #ffffff;
}
.logoBayer {
  margin-left: 0.49rem;
  width: 0.97rem;
  height: 0.97rem;
}
/* 淡入淡出动画 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
.popUp-productFamily {
  position: absolute;
  top: 1.51rem;
  width: 100%;
  height: calc(100vh - 1.51rem);
  background: #ffffff;
  z-index: 1;
  padding: 0 0.32rem;
  box-sizing: border-box;
}
.popup-listItem {
  padding: 0.4rem 0.22rem;
  box-sizing: border-box;
  border-bottom: 0.02rem solid #021d7b;
}
.popup-listItem-name {
  font-family: SourceHanSansSC-Bold;
  font-weight: bold;
  font-size: 0.3rem;
  color: #021d7b;
}
.popup-listItem-link {
  font-family: SourceHanSansSC-Regular;
  font-size: 0.3rem;
  color: #021d7b;
}
.iconExpand {
  width: 0.26rem;
  height: 0.17rem;
}
.popup-expansionItem {
  margin-top: 0.31rem;
  margin-left: 0.28rem;
}
.popup-expansionItem-name {
  font-family: SourceHanSansSC-Bold;
  font-weight: bold;
  font-size: 0.28rem;
  color: #021d7b;
}
.popup-expansionItem-link {
  font-family: SourceHanSansSC-Regular;
  font-size: 0.28rem;
  color: #021d7b;
}
.popup-jump {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 10000;
}

.jumpBox {
  width: 6.34rem;
  background: #ffffff;
  opacity: 0.95;
  border-radius: 0.1rem;
  padding: 0.42rem 0.34rem;
  box-sizing: border-box;
}

.jumpTxt1 {
  font-family: SourceHanSansSC-Bold;
  font-weight: bold;
  font-size: 0.33rem;
  color: #140e4f;
}

.jumpTxt2 {
  margin-top: 0.41rem;
  font-family: SourceHanSansSC-Regular;
  font-weight: 400;
  font-size: 0.21rem;
  color: #140e4f;
  line-height: 0.28rem;
}

.jumpTxt3 {
  margin-top: 0.18rem;
  font-family: SourceHanSansSC-Regular;
  font-weight: 400;
  font-size: 0.21rem;
  color: #140e4f;
  line-height: 0.28rem;
}

.btnContinue {
  width: 1.14rem;
  height: 0.4rem;
  border-radius: 0.03rem 0.03rem 0.03rem 0.03rem;
  border: 0.01rem solid #140e4f;
  font-family: Source Han Sans SC;
  font-weight: 400;
  font-size: 0.26rem;
  color: #140e4f;
  line-height: 0.26rem;
}

.btnCancel {
  width: 1.14rem;
  height: 0.44rem;
  background: #140e4f;
  border-radius: 0.03rem;
  font-family: Source Han Sans SC;
  font-weight: 400;
  font-size: 0.26rem;
  color: #ffffff;
  line-height: 0.26rem;
}
</style>
